import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import tagsListingMachine from "./machines/tagsListingMachine";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { interpret } from "xstate";
import { TagModule } from "@/store/modules/tag.module";
import TagUpsertComponent from "./components/TagUpsertComponent.vue";
import { TagSaveModel } from "@/store/models/tag/tagSaveDTO";
import DeleteComponent from "@/components/deleteComponent.vue";
import { GridOptionModel } from "@/store/models/shared/gridOption";
import { TagConstant } from "@/store/tagConstant";
let TagsListing = /** @class */ (() => {
    let TagsListing = class TagsListing extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Report Tags";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Masters",
                    href: "#",
                },
                {
                    text: "Report Tags",
                    active: true,
                },
            ];
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.searchData = new GridOptionModel();
            this.tagId = "";
            this.componentTitle = "";
            this.buttonName = "";
            this.unTaggedTagId = TagConstant.UnTagged();
            this.columns = [
                {
                    field: "tagName",
                    label: "Report Tag Name",
                    thClass: "tag-name",
                    filterOptions: {
                        enabled: true,
                        placeholder: "Enter Report Tag Name",
                        autoComplete: "off",
                    },
                },
                {
                    field: "description",
                    label: "Description",
                    thClass: "tag-description",
                    sortable: false,
                },
                // {
                //     field: "empty",
                //     label: "",
                //     thClass: "",
                //     sortable: false,
                // },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "tag-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "tagName",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            //   MACHINE
            this.machine = tagsListingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.machineService.send({ type: "GETTING_TAGS", searchData: searchData });
        }
        onRowClick() {
            return "";
        }
        get rows() {
            return TagModule.tags;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get totalTags() {
            return TagModule.totalCount;
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            // this.serverParams.page = this.initialPage;
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        showTagAddModal() {
            this.tagItem = new TagSaveModel();
            this.componentEvent("Add New Report Tag", "Save");
            this.machineService.send({ type: "ADD_TAG" });
        }
        tagModal() {
            let tagComponent = this.$refs["tagComponent"];
            tagComponent.showModal();
        }
        showEditTagModal(id) {
            const value = this.rows.find((item) => item.id == id);
            if (value) {
                const { id, tagName: name, description: tagDescription } = value;
                this.tagItem = { id, name, tagDescription };
                this.componentEvent("Edit Report Tag", "Update");
                this.machineService.send({ type: "EDIT_TAG" });
            }
        }
        saveTag(tag) {
            if (this.state.hasTag("showAddTagModal")) {
                this.machineService.send({ type: "ADDING_TAG", tag: tag });
            }
            else {
                this.machineService.send({ type: "UPDATING_TAG", tag: tag });
            }
        }
        stopLoading() {
            let tagComponent = this.$refs["tagComponent"];
            tagComponent.stopLoading();
        }
        loading() {
            let tagComponent = this.$refs["tagComponent"];
            tagComponent.loading();
        }
        componentEvent(title, button) {
            this.componentTitle = title;
            this.buttonName = button;
            this.tagModal();
        }
        showDeleteTagModal(id) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.tagId = id;
            this.machineService.send({ type: "DELETE_TAG", ispageChanged: isPageChanged });
        }
        deleteTag() {
            this.machineService.send({ type: "DELETING_TAG", tagId: this.tagId });
        }
        cancel() {
            this.machineService.send({ type: "CANCEL_TAG" });
        }
        tagDescPopover(value) {
            return value.length > 50 ? value : null;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("loadedTags")) {
                    this.totalCount = this.totalTags;
                    this.isGridLoading = false;
                }
                if ((this.state.matches("gettingTags") && previousState.matches("updatingTags")) || (this.state.matches("gettingTags") && previousState.matches("addingTags"))) {
                    this.stopLoading();
                }
                if ((this.state.matches("editTags") && previousState.matches("updatingTags")) || (this.state.matches("addTags") && previousState.matches("addingTags"))) {
                    this.loading();
                }
                if (this.state.matches("gettingTags") && previousState.matches("deletingTag")) {
                    this.isGridLoading = true;
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    TagsListing = __decorate([
        Component({
            name: "TagsListing",
            components: {
                Layout,
                PageHeader,
                EcGrid,
                TagUpsertComponent,
                DeleteComponent,
            },
        })
    ], TagsListing);
    return TagsListing;
})();
export default TagsListing;
